import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  List,
  ListItem,
  ListItemText,
  Radio,
  RadioGroup,
  TextField,
  Tooltip,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux';
import { useEffect, useRef, useState } from 'react';
import { fontSize, palette } from '../..';
import RichTreeViewControl from '../Controls/RichTreeViewControl';
import { getAllSubworkspace } from '../../api/workspace';
import { TAlert } from '../../types/types';
import {
  ConvertListOfListToRichTreeViewList,
  findNodeWithParent,
  isNameAllowed,
  Node,
} from '../CommonFunctions/CommonFunctions';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
  ResetDatasetState,
  SetDatasetName,
  SetIsExtract,
} from '../../redux/_Dataset/dataset.action';
import { createDataset, streamEndPoint, updateDataset } from '../../api';
import { IFilter, relationshipServerObjProps } from '../DataSet/types/BottomBarInterfaces';
import { NotificationDialog, PopUpSpinner } from '../CommonFunctions/DialogComponents';
import { messages } from '../CommonFunctions/aliases';
import ShortUniqueId from 'short-unique-id';
import { IArrow } from '../../redux/_Dataset/types';
import { format } from 'date-fns';
import ConfirmDialog from './ConfirmDialog';
interface IActionProps {
  datasetFilters: IFilter[];
  editMode?: boolean;
  invalidTables?: Set<string>;
}
function Actions({ datasetFilters, editMode, invalidTables = new Set() }: IActionProps) {
  const {
    name,
    selectedTables,
    isExtract,
    totalConnections,
    arrows,
    datasetId,
    canEdit,
    isEnterprise,
    connections,
  } = useSelector((state: RootState) => ({
    isExtract: state.dataset.isExtract,
    selectedTables: state.dataset.selectedTables,
    name: state.dataset.datasetName,
    totalConnections: state.dataset.connections.length,
    arrows: state.dataset.arrows,
    datasetId: state.dataset.datasetId,
    canEdit: state.dataset.canEdit,
    isEnterprise: state.isLogged.businessType === 'enterprise',
    connections: state.dataset.connections,
  }));

  const hasWebApi = connections.some((connection) => connection.fileType === 'webapi');
  const navigate = useNavigate();
  const location = useLocation();
  const [localName, setLocalName] = useState(name);
  const uid = new ShortUniqueId({ length: 12 });
  const [showWorkspace, setShowWorkspace] = useState(false);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [subWorkspaceList, setSubWorkspaceList] = useState<Array<Node>>([]);
  const [alert, setAlert] = useState<null | TAlert>(null);
  const [selectedWorkspace, setSelectedWorkspace] = useState<string>('');
  const [isStreaming, setIsStreaming] = useState(false);
  const { parentId } = useParams();
  const eventSourceRef = useRef<EventSource | null>(null);
  const [success, setSuccess] = useState(false);
  const [isNameValid, setIsNameValid] = useState(true);
  const [confirmUpdateOpen, setConfirmUpdateOpen] = useState(false);
  const dispatch = useDispatch();
  const getAndSetAllSubworkspace = async () => {
    const { data, isError, message } = await getAllSubworkspace();


    if (isError) {
      setAlert({
        severity: 'error',
        message,
      });
      return;
    }

    setSubWorkspaceList(ConvertListOfListToRichTreeViewList(data));
  };
  const [streamMessages, setStreamMessages] = useState<
    {
      id: string;
      tableName: string;
      status: 'started' | 'completed';
    }[]
  >([]);
  const [tables, setTables] = useState<
    { name: string; status: 'error' | 'success' | 'pending'; id: string }[]
  >([]);
  useEffect(() => {
    // if (editMode) {
    //   setSendOrUpdate('Update');
    // } else {
    getAndSetAllSubworkspace();
    // }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (!editMode) return;
    const initialState = { name, selectedTables, arrows, isExtract, datasetFilters };
    localStorage.setItem('initialDatasetState', JSON.stringify(initialState));
    localStorage.setItem('hasUnsavedChanges', 'false');
  }, []);

  const checkForUnsavedChanges = () => {
    const initial = localStorage.getItem('initialDatasetState');
    if (!initial) return false;
    const initialState = JSON.parse(initial);
    const currentState = { name: localName, selectedTables, arrows, isExtract, datasetFilters };
    return JSON.stringify(initialState) !== JSON.stringify(currentState);
  };
  useEffect(() => {
    if (!editMode) return;
    const hasChanges = checkForUnsavedChanges();
    localStorage.setItem('hasUnsavedChanges', String(hasChanges));
  }, [localName, selectedTables, arrows, isExtract, datasetFilters]);

  const clearDatasetEditStorage = () => {
    localStorage.removeItem('initialDatasetState');
    localStorage.removeItem('hasUnsavedChanges');
  };

  const streamBuilder = async (jobId: string) => {
    const eventSource = new EventSource(streamEndPoint(jobId));
    // const eventSource = new EventSource(`http://localhost:8080/api/stream?jobId=${jobId}`);
    eventSourceRef.current = eventSource;

    eventSource.addEventListener('status-update', (event: MessageEvent) => {
      console.log('Status event received:', event.data);
      const info = JSON.parse(event.data);

      setStreamMessages((prevMessages) => {
        const index = prevMessages.findIndex((msg) => msg.id === info.id);

        if (index === -1) {
          // Not found → append new
          return [...prevMessages, info];
        }

        // Found → return a new array with updated item
        return prevMessages.map((msg, i) => (i === index ? { ...msg, status: info.status } : msg));
      });
    });

    eventSource.onerror = (err) => {
      console.error('Stream error:', err);
      eventSource.close();
      // setIsStreaming(false);
      // setStreamMessages([]);
    };
    return await new Promise<void>((resolve) => {
      eventSource.onopen = () => {
        console.log('Stream opened');
        resolve();
      };
    });
  };
  const successRedirect = (workspaceId: string) => {
    if (editMode) {
      if (isExtract) navigate(-1);
      else
        setTimeout(() => {
          setAlert(null);
          navigate(-1);
        }, 2000);
      return;
    }
    const info = findNodeWithParent(subWorkspaceList, workspaceId);
    if (!info) {
      navigate('/');
      setTimeout(() => {
        setAlert(null);
        navigate(`/`);
      }, 2000);
      return;
    }
    /**
     * if parentLabel||parentId is falsy value that means current workspace is root label worksapce
     * else current workspace is subworkspace
     */
    localStorage.setItem('workspace', info.parentLabel ?? info.label);
    if (info.parentId) {
      localStorage.setItem('parentId', workspaceId);

      localStorage.setItem('subworkspace', info.label);

      localStorage.setItem('parentWorkspaceId', info.parentId);
      setLoading(false);
      if (!isExtract) {
        setTimeout(() => {
          setAlert(null);
          navigate(`/SubWorkspaceDetails/${workspaceId}`, {
            state: { childWorkspaceName: info.label },
          });
        }, 2000);
      } else
        navigate(`/SubWorkspaceDetails/${workspaceId}`, {
          state: { childWorkspaceName: info.label },
        });
    } else {
      if (isExtract) navigate(`/workspace/${workspaceId}`);
      else
        setTimeout(() => {
          setAlert(null);
          navigate(`/workspace/${workspaceId}`);
        }, 2000);
    }
  };

  const formatDateToYYYYMMDD = (date: unknown): string => {
    const parsedDate = date instanceof Date ? date : new Date(date as string);
    const validDate = isNaN(parsedDate.getTime()) ? new Date() : parsedDate;

    return format(validDate, 'yyyy-MM-dd');
  };
  const initiateStream = async (workspaceId: string) => {
    const jobId = uid();
    if (isExtract && isStreaming) return;
    setShowWorkspace(false);
    if (isExtract) {
      setIsStreaming(true);
      const tablesStatus: { name: string; status: 'error' | 'success' | 'pending'; id: string }[] =
        selectedTables.map((table) => {
          return { name: table.table, status: 'pending', id: table.id };
        });
      setTables(tablesStatus);
      await streamBuilder(jobId);
    } else {
      setLoading(true);
    }

    const relationshipServerObj: relationshipServerObjProps[] = [];
    const grouped_by_relation = arrows.reduce<Record<string | number, IArrow[]>>((acc, arrow) => {
      if (!acc[arrow.relationId]) {
        acc[arrow.relationId] = [];
      }
      acc[arrow.relationId].push(arrow);
      return acc;
    }, {});

    for (const [relationId, arrows] of Object.entries(grouped_by_relation)) {
      if (arrows.length === 0) continue;
      const { startId, endId, cardinality, integrity } = arrows[0];
      const relationObj: relationshipServerObjProps = {
        table1: startId,
        table2: endId,
        cardinality: cardinality,
        refIntegrity: integrity,
        table1Columns: [],
        table2Columns: [],
      };
      arrows.forEach((arrow) => {
        relationObj.table1Columns.push(arrow.startColumnName);
        relationObj.table2Columns.push(arrow.endColumnName);
      });
      relationshipServerObj.push(relationObj);
    }
    const datasetFilter: {
      panelName: 'datasetFilters';
      shouldAllConditionsMatch: boolean;
      filters: any[];
    } = { panelName: 'datasetFilters', shouldAllConditionsMatch: true, filters: [] };
    const filters = datasetFilters
      .map((item) => {
        if (item.filterType!=='relativeFilter' && item.userSelection.length === 0) return null;
        let excludeInclude = item.shouldExclude === false ? false : true;
        return {
          filterType: item.filterType,
          fieldName: item.fieldName,
          tableName: item.tableName,
          dataType: item.dataType,
          uid: item.uid,
          connectionId: item.connectionId,
          relativeCondition:
            item.filterType === 'relativeFilter'
              ? {
                  from: item.relativeCondition?.from ?? [],
                  to: item.relativeCondition?.to ?? [],
                  anchorDate:
                    item.relativeCondition?.anchorDate === 'specificDate'
                      ? formatDateToYYYYMMDD(item.userSelection[0]?.toString()) || ''
                      : item.relativeCondition?.anchorDate || '',
                }
              : undefined,
          displayName: item.displayName,
          shouldExclude: excludeInclude,
          timeGrain: item.filterType === 'relativeFilter' ? 'date' : item.timeGrain,
          operator: item.filterType === 'pickList' ? 'in' : item.operator,
          userSelection: item.userSelection,
          isTillDate: item.isTillDate,
          tableId: item.tableId,
          exprType: item.exprType,
        };
      })
      .filter((elem) => elem !== null);

    datasetFilter.filters = filters;

    // setLoading(true);
    const res = !editMode
      ? await createDataset({
          connection: !isExtract ? selectedTables[0].connectionId : 'federatedQuery',
          fname: localName,
          workspaceId: workspaceId,
          isFlatFile: selectedTables.every((table) => table.isFlatFile === true),
          tablesSelectedInSidebar: selectedTables.map((table) => {
            const { columns, ...rest } = table;
            const { connectionId, flatFileId } = table;
            const id = connectionId || flatFileId;
            const workspaceOfTable = connections.find((conn) => conn.id === id)?.workspaces;
            return { ...rest, workspaces: workspaceOfTable ?? [] };
          }),
          relationshipServerObj,
          datasetFilter: filters.length > 0 ? [datasetFilter] : [],
          isExtract,
          jobId,
        })
      : await updateDataset({
          connection: !isExtract ? selectedTables[0].connectionId : 'federatedQuery',
          datasetId: datasetId,
          fname: localName,
          workspaceId: location.state.parentId ?? '',
          isFlatFile: selectedTables.every((table) => table.isFlatFile === true),
          tablesSelectedInSidebar: selectedTables.map((table) => {
            const { columns, ...rest } = table;
            return rest;
          }),
          relationshipServerObj,
          datasetFilter: filters.length > 0 ? [datasetFilter] : [],
          isExtract,
          jobId,
        });
    if (res.isError) {
      setLoading(false);
      setShowWorkspace(false);
      setAlert({
        severity: 'error',
        message: res.message ?? `Unable to ${editMode ? 'update' : 'create'} the dataset}`,
      });
      eventSourceRef.current = null;
      // eventSource.close();
      setIsStreaming(false);
      setStreamMessages([]);
    } else {
      setLoading(false);
      setSuccess(true);
      if (!isExtract) {
        dispatch(ResetDatasetState());
        clearDatasetEditStorage();

        setAlert({
          severity: 'success',
          message: `Dataset ${editMode ? 'updated' : 'created'} successfully`,
        });
        successRedirect(workspaceId);
      }
    }
  };
  const handleProceedButtonClick = async (selectedWorkspaceID: string, list: any) => {
    if (!selectedWorkspaceID) {
      setAlert({
        severity: 'error',
        message: 'Please select a workspace',
      });
      return;
    }

    // setIsSubWorkspaceSelected(!list.find((item: any) => item.id === selectedWorkspaceID));

    setSelectedWorkspace(selectedWorkspaceID);

    await initiateStream(selectedWorkspaceID);
  };
  const onCancelOnDataset = () => {
    if (editMode) {
      const hasUnsavedChanges = localStorage.getItem('hasUnsavedChanges') === 'true';

      if (!hasUnsavedChanges) {
        clearDatasetEditStorage();
        navigate(-1);
        return;
      }
    }

    setOpen(true);
  };

  function hasCycle(graph: Record<string, Set<string>>): boolean {
    const visited = new Set<string>();
    const parentMap = new Map<string, string | null>();

    function dfs(node: string, parent: string | null): boolean {
      visited.add(node);
      parentMap.set(node, parent);

      for (const neighbor of graph[node]) {
        if (!visited.has(neighbor)) {
          if (dfs(neighbor, node)) return true;
        } else if (parentMap.get(node) !== neighbor) {
          // Found a back edge -> cycle
          return true;
        }
      }
      return false;
    }

    for (const node in graph) {
      if (!visited.has(node) && dfs(node, null)) {
        return true;
      }
    }
    return false;
  }
  function validateTableConnections(tableIds: string[]) {
    // Build adjacency list
    const graph: Record<string, Set<string>> = {};
    tableIds.forEach((id) => (graph[id] = new Set()));

    for (const relation of arrows) {
      const { startId, endId } = relation;
      if (graph[startId] && graph[endId]) {
        graph[startId].add(endId);
        graph[endId].add(startId);
      }
    }

    // BFS/DFS from first table
    const visited = new Set<string>();
    const stack = [tableIds[0]];

    while (stack.length > 0) {
      const current = stack.pop()!;
      if (!visited.has(current)) {
        visited.add(current);
        stack.push(...graph[current]);
      }
    }

    // If not all selected tables are visited, graph is disconnected
    if (visited.size !== tableIds.length) {
      throw new Error(
        `Broken relationship detected!\nPlease make sure that every table is connected to all other tables directly or indirectly.`,
      );
    }
    if (hasCycle(graph)) {
      throw new Error(
        `Ambiguous connection path detected.\nBetween every two tables, there should be only one connection path. Please remove additional connections.`,
      );
    }
  }
  const checkValidityOfDataset = async () => {
    const hasUnsavedChanges = localStorage.getItem('hasUnsavedChanges') === 'true';

    // Web API Validation Check
    if (invalidTables.size > 0) {
      setAlert({
        severity: 'error',
        message: 'Some tables are invalid, you need to select new tables from Select Data Nodes.',
      });
      return;
    }

    if (!canEdit) {
      setAlert({
        severity: 'error',
        message: 'You do not have the permision to Edit',
      });
      return;
    }
    if (localName.length > 40) {
      setAlert({
        severity: 'error',
        message: 'Dataset name should not exceed 40 characters',
      });
      return;
    }
    if (!isNameAllowed(localName)) {
      setAlert({
        severity: 'error',
        message: messages.dataset.wrongName,
      });
      return;
    }
    if (selectedTables.length === 0) {
      setAlert({
        severity: 'error',
        message: 'Please add atleast one table',
      });
      return;
    }
    if (selectedTables.length === 1) {
      if (!editMode) setShowWorkspace(true);
      else {
        if (hasUnsavedChanges) {
          setConfirmUpdateOpen(true);
        } else {
          await initiateStream('');
        }
        return;
      }
    }
    // const connectedTableIds = new Set<string>();
    // arrows.forEach(({ startTableName, endTableName }) => {
    //   connectedTableIds.add(startTableName);
    //   connectedTableIds.add(endTableName);
    // });
    const tableIds = selectedTables.map((table) => table.id);

    try {
      validateTableConnections(tableIds);
    } catch (error: any) {
      setAlert({
        severity: 'error',
        message: error.message ?? 'Some error has occurred, please check your dataset',
      });
      return;
    }

    if (!editMode) setShowWorkspace(true);
    else {
      if (hasUnsavedChanges) {
        setConfirmUpdateOpen(true);
      } else {
        await initiateStream('');
      }
      return;
    }
  };

  const isSaveDisabled = invalidTables.size > 0;

  return (
    <Box
      sx={{
        borderTop: '1px solid #e0e0e0',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        px: 2,
        height: '3rem',
        paddingRight: '2.7rem',
      }}
    >
      {showWorkspace ? (
        <RichTreeViewControl
          currentWorkspace={parentId}
          proceedButtonName={'Save'}
          list={subWorkspaceList}
          title={'Select a Workspace'}
          showInPopup={showWorkspace}
          handleCloseButtonClick={(e: any) => {
            setShowWorkspace(false);
          }}
          handleProceedButtonClick={handleProceedButtonClick}
        ></RichTreeViewControl>
      ) : null}

      {isStreaming ? (
        <Dialog
          open={isStreaming}
          // sx={sx}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          onClose={() => {
            if (!success) return;
            dispatch(ResetDatasetState());
            successRedirect(selectedWorkspace);
            setIsStreaming(false);
          }}
        >
          <DialogTitle
            sx={{
              fontSize: fontSize.large,
              fontWeight: '600',
            }}
          >
            Table Extract
          </DialogTitle>
          <DialogContent
            sx={{
              width: '25rem',
            }}
          >
            <List>
              {tables.map((table) => {
                const info = streamMessages.find((msg) => msg.id === table.id);
                return (
                  <ListItem disablePadding>
                    {!success && (!info || info?.status === 'started') ? (
                      <div
                        className=""
                        style={{
                          width: '20px',
                          height: '20px',
                          borderRadius: '50%',
                          background: 'orange',
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#ffffff"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-loader-circle-icon lucide-loader-circle animate-spin"
                        >
                          <path d="M21 12a9 9 0 1 1-6.219-8.56" />
                        </svg>
                      </div>
                    ) : (
                      <div
                        className=""
                        style={{
                          width: '20px',
                          height: '20px',
                          borderRadius: '50%',
                          background: '#2bb9bb',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#ffffff"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-check-icon lucide-check"
                        >
                          <path d="M20 6 9 17l-5-5" />
                        </svg>
                      </div>
                    )}

                    <ListItemText primary={table.name} sx={{ ml: 1 }} />
                  </ListItem>
                );
              })}
              {success && (
                <ListItem disablePadding>
                  <div
                    className=""
                    style={{
                      width: '20px',
                      height: '20px',
                      borderRadius: '50%',
                      background: '#2bb9bb',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#ffffff"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-check-icon lucide-check"
                    >
                      <path d="M20 6 9 17l-5-5" />
                    </svg>
                  </div>

                  <ListItemText
                    primary={`Dataset ${!editMode ? 'created' : 'updated'} successfully`}
                    sx={{ ml: 1 }}
                  />
                </ListItem>
              )}
            </List>
          </DialogContent>
          <DialogActions>
            {success && (
              <Button
                onClick={() => {
                  if (!success) return;
                  dispatch(ResetDatasetState());
                  clearDatasetEditStorage();
                  successRedirect(selectedWorkspace);
                  setIsStreaming(false);
                }}
              >
                OK
              </Button>
            )}
          </DialogActions>
        </Dialog>
      ) : null}

      {/*Live, extract radio buttons for enterprise version only */}
      {isEnterprise && (
        <FormControl
          sx={{
            height: '100%',
            verticalAlign: 'middle',
            justifyContent: 'center',
          }}
        >
          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            value={
              isExtract ||
              hasWebApi ||
              (selectedTables.length > 0 && selectedTables.every((table) => table.isFlatFile))
                ? 'extract'
                : 'live'
            }
            name="radio-buttons-group"
            row
            sx={{
              flexWrap: 'nowrap',
            }}
            onChange={(e: any) => {
              if (hasWebApi) return;
              const val = e.target.value;
              dispatch(SetIsExtract(val === 'extract'));
            }}
          >
            <Tooltip
              title="Data is fetched directly from DB on every time."
              slotProps={{
                tooltip: {
                  sx: {
                    fontSize: '12px',
                  },
                },
              }}
            >
              <FormControlLabel
                value="live"
                control={
                  <Radio
                    sx={{
                      color: 'gray',
                      '&.Mui-checked': {
                        color: 'gray',
                      },
                    }}
                  />
                }
                label={
                  <Box
                    sx={{
                      maxWidth: 60,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    Live
                  </Box>
                }
                disabled={
                  !canEdit ||
                  hasWebApi ||
                  totalConnections > 1 ||
                  (selectedTables.length > 0 && selectedTables.every((table) => table.isFlatFile))
                }
              />
            </Tooltip>
            <Tooltip
              title="A copy of data is saved in Silzila. (You have to periodically update the extract if you want latest data)
"
              slotProps={{
                tooltip: {
                  sx: {
                    fontSize: '12px',
                  },
                },
              }}
            >
              <FormControlLabel
                value="extract"
                control={
                  <Radio
                    sx={{
                      color: 'gray',
                      '&.Mui-checked': {
                        color: 'gray',
                      },
                    }}
                  />
                }
                label={
                  <Box
                    sx={{
                      maxWidth: 60,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    Extract
                  </Box>
                }
                disabled={
                  !canEdit ||
                  hasWebApi ||
                  selectedTables.every((table) => table.isFlatFile === true)
                }
              />
            </Tooltip>
          </RadioGroup>
        </FormControl>
      )}

      <Box
        sx={{
          display: 'flex',
          gap: 1,
          height: '2rem',
          marginLeft: 'auto',
        }}
      >
        <Tooltip
          title={isNameValid ? 'Click to Edit' : 'Dataset name should not exceed 40 characters'}
          sx={{
            '& .MuiTextField-root': { margin: 1, width: '20px' },
            fontSize: '12px',
          }}
        >
          <TextField
            // disabled={editMode && viewerRestriction}
            variant="outlined"
            id="margin-none"
            sx={{
              flex: '0 1 200px',
              margin: '0 20px',
              maxWidth: '200px',
              fontSize: fontSize.medium,
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: isNameValid ? undefined : 'red',
                },
                '&:hover fieldset': {
                  borderColor: isNameValid ? undefined : 'red',
                },
                '&.Mui-focused fieldset': {
                  borderColor: isNameValid ? '#2BB9BB' : 'red',
                },
              },
              '& .MuiInputLabel-root': {
                color: isNameValid ? undefined : 'red',
              },
              '& .MuiInputLabel-root.Mui-focused': {
                color: isNameValid ? '#2BB9BB' : 'red',
              },
            }}
            inputProps={{
              style: {
                fontSize: fontSize.medium,
                // padding: '0 16px 0 1px', // Adjust padding for better alignment
                color: palette.primary.contrastText,
                lineHeight: '1.5', // Ensure line-height matches your design
              },
            }}
            InputProps={{
              style: {
                height: '2rem',
                transform: 'translateX(10px)',
              },
            }}
            InputLabelProps={{
              sx: {
                paddingLeft: '0.875rem',
              },
            }}
            size="small"
            onChange={(e) => {
              e.preventDefault();
              const value = e.target.value;
              setLocalName(value);
              setIsNameValid(value.length <= 40);
            }}
            value={localName}
            label="Dataset Name"
            onBlur={() => {
              dispatch(SetDatasetName(localName));
            }}
            disabled={!canEdit}
          />
        </Tooltip>
        <Button
          variant="contained"
          onClick={onCancelOnDataset}
          id="cancelButton"
          sx={{
            textTransform: 'none',
            fontSize: fontSize.medium,
            lineHeight: 'normal',
            marginRight: 0,
          }}
        >
          {editMode ? 'Back' : 'Cancel'}
        </Button>
        <Button
          variant="contained"
          onClick={checkValidityOfDataset}
          disabled={!canEdit}
          id="setButton"
          sx={{
            textTransform: 'none',
            fontSize: fontSize.medium,
            lineHeight: 'normal',
            marginRight: '0.2rem',
            // cursor: viewerRestriction ? 'not-allowed' : 'pointer',
            '&:disabled': {
              cursor: 'not-allowed',
              pointerEvents: 'auto',
            },
          }}
          // disabled={viewerRestriction}
          style={{ backgroundColor: '#2BB9BB' }}
        >
          {/* {sendOrUpdate} */}
          {editMode ? 'Update' : 'Save'}
        </Button>
      </Box>

      {alert && (
        <NotificationDialog
          onCloseAlert={() => setAlert(null)}
          severity={alert.severity}
          testMessage={alert.message}
          openAlert={!!alert}
          splitLines
        />
      )}
      <PopUpSpinner
        show={loading}
        paperProps={{
          sx: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          },
        }}
      />
      <Dialog open={open}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            padding: '10px',
            width: '350px',
            height: 'auto',
            justifyContent: 'center',
          }}
        >
          <div style={{ fontWeight: 'bold', textAlign: 'center', padding: '0.5rem' }}>
            <div
              style={{
                fontSize: fontSize.large,
              }}
            >
              {editMode ? 'CANCEL DATASET EDIT' : 'CANCEL DATASET CREATION'}
              <button
                style={{ background: 'none', border: 'none', cursor: 'pointer', float: 'right' }}
                onClick={() => setOpen(false)}
              >
                <Close />
              </button>
            </div>
            <br />
            <p style={{ fontWeight: 'normal' }}>
              {editMode
                ? 'Any unsaved changes will be discarded, do you want to exit anyway?'
                : 'Cancel will reset this dataset creation. Do you want to discard the progress?'}
            </p>
          </div>
          <div
            style={{
              padding: '15px',
              justifyContent: 'space-around',
              display: 'flex',
            }}
          >
            <Button
              sx={{
                backgroundColor: 'white',
                border: '1px solid gray',
                marginLeft: '8px',
                width: '105px',
                fontSize: fontSize.medium,
                boxShadow: 'none',
                '&:hover': {
                  backgroundColor: 'gray',
                  color: 'white',
                },
              }}
              variant="contained"
              onClick={() => {
                setOpen(false);
              }}
            >
              Back
            </Button>
            <Button
              sx={{
                backgroundColor: 'white',
                border: '1px solid gray',
                marginLeft: '8px',
                width: '105px',
                fontSize: fontSize.medium,
                boxShadow: 'none',
                '&:hover': {
                  border: '1px solid red',
                  backgroundColor: 'red',
                  color: 'white',
                },
              }}
              variant="contained"
              onClick={() => {
                dispatch(ResetDatasetState());
                setOpen(false);
                // if (editMode) {
                navigate(-1);
                //}
              }}
            >
              Ok
            </Button>
          </div>
        </div>
      </Dialog>

      <ConfirmDialog
        open={confirmUpdateOpen}
        title="Save Changes?"
        message="Changes in this dataset may cause issues in the dependant playbooks of this dataset. Are you sure?"
        confirmText="Update"
        cancelText="Cancel"
        onConfirm={async () => {
          setConfirmUpdateOpen(false);
          await initiateStream('');
        }}
        onCancel={() => setConfirmUpdateOpen(false)}
      />
    </Box>
  );
}

export default Actions;
